import {Helmet} from "react-helmet";
import classes from "../../../css/styles.module.scss";
import {Link} from "react-router-dom";

const Products = () =>{
  return (
    <div>
      <Helmet><title>Backend Helpers Limited | products </title></Helmet>
      <section id="projects" className={`${classes['container-s']} ${classes.projects}`}>

        <div  className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}>Eco-Rolling AI: <br/>Artificial Intelligence <br/>  for Tourism </h2>
            <button type="button" className={classes['project-btn']}><Link to="/en/products/eco-rolling-ai" >See more </Link></button>
          </div>
        </div>

        <div  className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}> DevOps and <br/>
              Full Stack <br/> Academy </h2>
            <button type="button" className={classes['project-btn']}><Link to="/en/products/academy" >See more </Link></button>
          </div>
        </div>

      </section>

      <section id="projects2" className={`${classes['container-s']} ${classes.projects}`}>

        <div  className={`${classes['project-card-border']} ${classes['mr-2']}`}>
          <div className={classes['project-card']}>
            <h2 className={classes['project-card-title']}>StepForward Digital: Cloud Computing  <br/> Digital Transformations  </h2>
            <button type="button" className={classes['project-btn']}><Link to="/en/products/step-forward-digital" >See more </Link></button>
          </div>
        </div>

      </section>

    </div>
  );
};

export default Products;